import * as React from 'react';

export default () => <div className="__-sps" />;
